import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Get host profile
export const getHostProfile = async (userId) => {
  const hostDoc = await getDoc(doc(db, 'hosts', userId));
  if (!hostDoc.exists()) {
    return null;
  }
  return { userId, ...hostDoc.data() };
};

// Create host profile (via backend API)
// This is handled by the backend to ensure proper role assignment

// Update host profile
export const updateHostProfile = async (userId, updates) => {
  const hostRef = doc(db, 'hosts', userId);
  await updateDoc(hostRef, {
    ...updates,
    updatedAt: new Date().toISOString(),
  });
};

